module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'field field--' + _vm.type,
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [(_vm.label) ? _c('label', [_vm._v(_vm._s(_vm.label) + " "), (_vm.required) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.text
    },
    on: {
      "keyup": [_vm.changeText, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeText($event)
      }],
      "blur": _vm.changeText
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9eb38a80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/LabelInput.vue
// module id = 1027
// module chunks = 0